import {observable} from "mobx";
import {Template} from "./Template";
import TemplateModeInterface from "./TemplateInterface";
import {logoWidget, menuDataWidget, postDataWidget, postLargeDataWidget, titleWidget} from "./templateData_temp";
import TemplateInterface from "./TemplateInterface";
import uuidv4 from 'uuid/v4';

class TemplateStore {

    @observable templates: TemplateModeInterface[] = [
        {
            id: 0,
            key: uuidv4(),
            displayName: 'Large post',
            widgets: [logoWidget, menuDataWidget, postLargeDataWidget, postDataWidget, postDataWidget]
        },
        {
            id: 1,
            key: uuidv4(),
            displayName: 'Campaign',
            widgets: [logoWidget, titleWidget, postLargeDataWidget, postDataWidget]
        },
        {
            id: 2,
            key: uuidv4(),
            displayName: 'Without menu',
            widgets: [logoWidget, postDataWidget, postLargeDataWidget, postDataWidget]
        },
    ];
    getTemplate = (index: number): TemplateInterface => JSON.parse(JSON.stringify(this.templates[index]));

    createTemplate(template: TemplateInterface): Template {
        return new Template(template);
    }

}

export default TemplateStore;
